import React, { useContext } from "react";

import { ProductsContext } from '../context/products.context';

import { Tab } from '@headlessui/react'

export default function LeftSidebar({ nontradFemaleCount, nontradMaleCount }) {

    const { setMainCategory, mainCategory, setFilterSession, filterSession, categories, nontrad, categoryMappings} = useContext(ProductsContext)

    // Handle category toggle with auto-matching
    const handleCategoryToggle = (newCategory) => {
      if (newCategory === mainCategory) return;

      setMainCategory(newCategory);

      // Skip auto-matching for non-traditional filters
      if (filterSession.startsWith('nontrad-')) return;

      // Auto-match to closest category
      if (newCategory === "Cluster" && categoryMappings?.programToCluster?.[filterSession]) {
        setFilterSession(categoryMappings.programToCluster[filterSession]);
      } else if (newCategory === "Program" && categoryMappings?.clusterToProgram?.[filterSession]) {
        setFilterSession(categoryMappings.clusterToProgram[filterSession]);
      }
    }

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
      }

    return (
        <div className=
        "bg-white print:hidden select-none border-gray-100 border-r-2 fixed z-20 mt-10 inset-0 top-[3.8125rem] left-4 right-auto w-[19.5rem] pb-10 px-8 overflow-y-auto">
<Tab.Group
 >    <div className="shadow-md shadow-white bg-white sticky top-0 pt-10 z-40 h-[100px]">
       <Tab.List className="flex mt-5 rounded-xl bg-gray-500/10 p-0">
      <div className="mt-0 space-x-1 z-20 absolute w-[240px] flex group">
    <button className={`${mainCategory === "Cluster" ? "text-slate-500" : 'text-indigo-500'} hover:text-indigo-500 w-[155px] h-[37px]`} onClick={() => handleCategoryToggle("Program")}>Program</button>
    <button className={`${mainCategory === "Program" ? "text-slate-500" : 'text-indigo-500'} hover:text-indigo-500  w-[155px] h-[37px]`} onClick={() => handleCategoryToggle("Cluster")}>Cluster</button></div>
    <div      className=
      "relative inline-flex w-[300px] h-[36px] bg-slate-50 cursor-pointer rounded-lg transition-colors duration-200 border-[1px] ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75"
    >


      <span
        aria-hidden="true"
        className={`${mainCategory === "Cluster" ? 'translate-x-[120px]  ' : 'translate-x-0 '}
          pointer-events-none inline-block w-[123px] transform rounded-lg   border-indigo-500 border-[1px] transition duration-200 ease-in-out`}
      />
    </div>
        </Tab.List ></div>
        <Tab.Panels>

            <div

              className={classNames(
                'rounded-xl  p-0 mt-4 cursor-pointer',
                   )}
            >
              <ul>
                {mainCategory === "Program" ? categories.Program && categories.Program.map ((cat) => (
                  cat.title !== "" && cat.title !== "All Program Areas" && <li
                  onClick={() => setFilterSession(cat.title === filterSession ? "Program Area Totals" : cat.title)}

                    key={cat.id}
                    className={cat.title === filterSession ? "bg-indigo-50 text-blue-700 relative border-l-2 border-l-indigo-400 rounded-r-sm p-1 cursor-pointer pl-4 " : " pl-4 relative text-slate-700 border-l-2 border-l-gray-100 hover:border-l-2 hover:border-l-slate-100 rounded-r-sm p-1 hover:bg-gray-50 hover:text-black"}
                  >
                    <h3 className="text-sm leading-7">
                      {cat.title}
                    </h3>
                             </li>
                )) : categories.Cluster && categories.Cluster.map ((cat) => (
                  cat.title !== "" &&  <li
                  onClick={() => setFilterSession(cat.title === filterSession ? "Career Cluster Totals" : cat.title)}
                    key={cat.id}
                    className={cat.title === filterSession ? "bg-indigo-50 text-blue-700 relative border-l-2 border-l-indigo-400 rounded-r-sm p-1 cursor-pointer pl-4" : "pl-4 relative text-slate-700 border-l-2 border-l-gray-100 hover:border-l-2 hover:border-l-slate-100 rounded-r-sm p-1 hover:bg-gray-50 hover:text-black"}
                  >
                    <h3 className="text-sm leading-7 ">
                      {cat.title}
                    </h3>
                             </li>
                ))}
              </ul>
            </div>

        </Tab.Panels>
      </Tab.Group>

        {/* Non-Traditional Section */}
        <div className="mt-6 pt-4 border-t border-gray-200">
          <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2 pl-4">
            Non-Traditional
          </h4>
          <ul>
            <li
              onClick={() => setFilterSession("nontrad-female")}
              className={filterSession === "nontrad-female"
                ? "bg-indigo-50 text-blue-700 relative border-l-2 border-l-indigo-400 rounded-r-sm p-1 cursor-default pl-4"
                : "pl-4 relative text-slate-700 border-l-2 border-l-gray-100 hover:border-l-2 hover:border-l-slate-100 rounded-r-sm p-1 hover:bg-gray-50 hover:text-black cursor-pointer"}
            >
              <h3 className="text-sm leading-7">Female ({nontradFemaleCount ?? nontrad.female.length})</h3>
            </li>
            <li
              onClick={() => setFilterSession("nontrad-male")}
              className={filterSession === "nontrad-male"
                ? "bg-indigo-50 text-blue-700 relative border-l-2 border-l-indigo-400 rounded-r-sm p-1 cursor-default pl-4"
                : "pl-4 relative text-slate-700 border-l-2 border-l-gray-100 hover:border-l-2 hover:border-l-slate-100 rounded-r-sm p-1 hover:bg-gray-50 hover:text-black cursor-pointer"}
            >
              <h3 className="text-sm leading-7">Male ({nontradMaleCount ?? nontrad.male.length})</h3>
            </li>
          </ul>
        </div>
      </div>)}